<template>
  <div class="modal-container">
    <div class="blur-backdrop" @click="close" />
    <div class="modal change-or-update-num-seats">
      <div class="title">
        Upgrade your plan
      </div>
      <div class="explanatory-text change-or-update-num-seats">
        Your new plan will come with {{ numStarterSeats }} seats included.
        You have the option to purchase additional seats.
        Note that you can add or remove seats later at any time.
      </div>
      <div class="input-row">
        <span>
          {{ numStarterSeats }} starter seats
        </span>
      </div>
      <div class="input-row">
        <span> + </span>
        <input
          class="change-or-update-num-seats"
          :class="{'disabled': showSpinner}"
          v-model.number="numAdditionalSeats"
          type="number"
          min="0"
          step="1"
        >
        <span>
          additional seats
        </span>
      </div>
      <div class="input-row bottom-padded">
        <span>
          = {{ numStarterSeats + numAdditionalSeats }} total seats
        </span>
      </div>
      <SpinnerButton
        class="button center"
        :isProcessing="showSpinner"
        @click="upgradePlan"
      >
        Proceed to Payment
      </SpinnerButton>
      <SpinnerButton
        class="button center danger"
        :isDisabled="showSpinner"
        :showSpinner="false"
        @click="close"
      >
        Go Back
      </SpinnerButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { loadStripe } from '@stripe/stripe-js';
import SpinnerButton from '@/components/utilComponents/SpinnerButton.vue';

export default Vue.extend({
  name: 'CreateSubscriptionModal',
  components: {
    SpinnerButton
  },
  data: () => ({
    stripe: {},
    showSpinner: false,
    sessionId: '',
    numStarterSeats: 8,  // Possible TODO: Create backend endpoint to fetch numStarterSeats instead of hardcoding here
    numAdditionalSeats: 0
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  watch: {
    numAdditionalSeats: function() {
      this.validateNumAdditionalSeats();
    }
  },
  methods: {
    validateNumAdditionalSeats() {
      if (this.numAdditionalSeats) {
        if (this.numAdditionalSeats < 0) {
          this.numAdditionalSeats = null;
        } else if (!Number.isInteger(this.numAdditionalSeats)) {
          this.numAdditionalSeats = Math.floor(this.numAdditionalSeats);
        }
      }
    },
    async upgradePlan() {
      try {
        this.showSpinner = true;
        await this.ensureStripeCustomer();
        await this.getSessionId();
        await this.checkout();
      } catch (error) {
        console.log('Error:', error);
        this.showSpinner = false;
      }
    },
    async ensureStripeCustomer() {
      await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/ensurestripecustomer`, {
        auth0UserId: this.auth0UserId,
        emailAddress: this.$auth.user.email
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${this.idToken}`
        }
      });
    },
    async getSessionId() {
      try {
        const response = await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/createcheckoutsessionpro`, {
          auth0UserId: this.auth0UserId,
          numAdditionalSeats: this.numAdditionalSeats || 0
        }, {
          headers: {
            'Content-Type': 'application/json', 
            'Authorization': `Bearer ${this.idToken}`
          }
        });
        this.sessionId = response.data.sessionId;
      } catch (error) {
        console.log('Error:', error);
      }
    },
    checkout() {
      if (this.sessionId.length > 0) {
        this.stripe.redirectToCheckout({
          sessionId: this.sessionId
        });
      }
    },
    close() {
      if (this.showSpinner) {
        return;
      }
      this.$emit('close');
    }
  },
  created: async function() {
    this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/modal-styles.scss';
</style>
